import { environment } from 'environments/environment';
import { getSentryIntegrations } from './sentry.integrations';
import { sanitizeSentryEvent } from './sentry.sanitization';

export function getSentryConfig() {
  return {
    dsn: environment.sentryDsn,
    // Note: environment and release removed - now set as custom tags in main.ts
    // to match exact property names (appEnvironment, appVersion, clientName)
    integrations: getSentryIntegrations(),
    tracesSampleRate: environment.production ? 0.1 : 1.0,
    replaysSessionSampleRate: 0,  // 5% of normal sessions (reduced from 10% to save quota)
    replaysOnErrorSampleRate: environment.production ? 0.1 : 1.0,   // 100% of error sessions (always capture errors)
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/.*\.aveapplications\.com/
    ],
    beforeSend: sanitizeSentryEvent
  };
}
